var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Van = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M11.25 13.5H9V15h2.25v-1.5Z" }),
    React.createElement("path", { fill: "currentColor", d: "M20 15h-2.7v-1.5h1.2v-3.4l-6.55-5.6H1.5v9h1.25V15H0V3h12.55L20 9.4V15Z" }),
    React.createElement("path", { fill: "currentColor", d: "M5.95 16.65a2.15 2.15 0 1 0 0-4.3 2.15 2.15 0 0 0 0 4.3Zm8.3 0a2.15 2.15 0 1 0 0-4.3 2.15 2.15 0 0 0 0 4.3Zm5-6.15H12V4h1.5v5h5.75v1.5Z" }))); });
//# sourceMappingURL=Van.js.map